const SHIPSY_REMARK = 'Shipsy-inventory-adjustment'

module.exports = { SHIPSY_REMARK }
